import styles from "./index.module.scss";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFilterUrl, getType } from "../../../../utils";
import { useRouter } from "next/router";
import { getPersonalAutos } from "/redux/action-creaters/user";
import Auto from "/components/common/auto";
import clsx from "clsx";
import Icon from "/components/common/icon";

export default function Selector({ sectionPageUrl, isBaltex = false }) {
  const dispatch = useDispatch();
  const router = useRouter();
  const { autos } = useSelector((state) => state.user);
  const { marks, models, types } = useSelector((state) => state.models);
  const { params } = useSelector((state) => state.filter);

  const resetAll = () => {
    router.push(getFilterUrl(sectionPageUrl));
  };

  const changeMark = (value) => {
    if (!value) {
      return;
    }
    if (typeof localStorage === "object") {
      localStorage.setItem("mark_", value);
      localStorage.setItem("model_", "");
      localStorage.setItem("type_", "");
    }
    router.push(getFilterUrl(sectionPageUrl, params, { marka: value }));
  };

  const changeModel = (value) => {
    if (!value) {
      return;
    }
    if (typeof localStorage === "object") {
      localStorage.setItem("model_", value);
      localStorage.setItem("type_", "");
    }
    router.push(getFilterUrl(sectionPageUrl, params, { model: value }));
  };

  const changeTypes = (value) => {
    if (!value) {
      return;
    }
    if (typeof localStorage === "object") {
      localStorage.setItem("type_", value);
      localStorage.setItem(
        "filterUrl",
        `/filter/marka-${params.marka?.[0]}/model-${params.model?.[0]}/kuzov-${value}`,
      );
    }
    router.push(getFilterUrl(sectionPageUrl, params, { kuzov: value }));
  };

  useEffect(() => {
    dispatch(getPersonalAutos());
  }, []);

  const [isSelectOther, setIsSelectOther] = useState(false);

  const selectedAuto = useMemo(() => {
    return (
      autos &&
      autos.find((auto) => {
        if (
          auto.MARK_CODE === params.marka?.[0] &&
          auto.MODEL_CODE === params.model?.[0] &&
          auto.CODE === params.kuzov?.[0]
        ) {
          return true;
        }
        return false;
      })
    );
  }, [autos, params]);

  useEffect(() => {
    const somethingSelected =
      params.marka?.[0] || params.model?.[0] || params.kuzov?.[0];
    if (somethingSelected && !selectedAuto) {
      setIsSelectOther(true);
    }
  }, [params, selectedAuto]);

  const isShowMyAutos = useMemo(() => {
    if (autos.length > 0 && !isSelectOther) {
      return true;
    }
    return false;
  }, [autos, isSelectOther]);

  const markKeys = Object.keys(marks).sort();
  const modelsKeys = Object.keys(models).sort();

  return markKeys.length > 0 ? (
    <>
      <div className={styles.MobileSelector}>
        <div>
          <span>Марка</span>
          <Icon width={7} height={15} id="arrow" fill={"#fff"} />
        </div>
        <div>
          <span>Модель</span>
          <Icon width={7} height={15} id="arrow" fill={"#fff"} />
        </div>
        <div>
          <span>Кузов</span>
          <Icon width={7} height={15} id="arrow" fill={"#fff"} />
        </div>
      </div>
      <div className={clsx(isBaltex && styles.SelectorBaltex, styles.Selector)}>
        <div className={styles.Title}>
          Выберите автомобиль
          {params?.marka && (
            <span
              className={styles.Close}
              onClick={() => {
                if (typeof localStorage === "object") {
                  localStorage.setItem("filterUrl", "");
                }
                router.push(`${sectionPageUrl}filter/`);
              }}
            >
              <Icon id="close" fill={"#fff"} width={22} height={22} />
            </span>
          )}
        </div>

        {isShowMyAutos && (
          <>
            <div className={styles.Cars}>
              {Array.isArray(autos) &&
                autos.map((auto) => (
                  <div
                    key={auto.ID}
                    className={clsx(
                      styles.Auto,
                      selectedAuto?.ID === auto.ID && styles.AutoSelected,
                    )}
                    onClick={() => {
                      if (typeof localStorage === "object") {
                        localStorage.setItem(
                          "filterUrl",
                          `/filter/${auto.URL}`,
                        );
                      }
                      router.push(`${sectionPageUrl}filter/${auto.URL}`);
                    }}
                  >
                    <Auto auto={auto} />
                  </div>
                ))}
            </div>
            <div
              className={styles.SelectOther}
              onClick={() => setIsSelectOther(true)}
            >
              Выбрать другой авто
              <Icon width={20} height={15} id="arrowcatalog" />
            </div>
          </>
        )}

        {!isShowMyAutos && (
          <>
            <select
              value={params?.marka}
              onChange={(event) => changeMark(event.target.value)}
              placeholder="Марка"
            >
              <option key={0} value={""}>
                Марка
              </option>
              {markKeys.map((markCode) => (
                <option key={markCode} value={markCode}>
                  {marks[markCode].NAME}
                </option>
              ))}
            </select>
            {modelsKeys.length > 0 && (
              <select
                value={params?.model}
                onChange={(event) => changeModel(event.target.value)}
              >
                <option key={0} value={""}>
                  Модель
                </option>
                {modelsKeys.map((modelCode) => (
                  <option key={modelCode} value={modelCode}>
                    {models[modelCode]?.NAME}
                  </option>
                ))}
              </select>
            )}
            {Object.keys(types).length > 0 && (
              <select
                value={params?.kuzov}
                onChange={(event) => changeTypes(event.target.value)}
              >
                <option key={0} value={""}>
                  Кузов
                </option>
                {Object.keys(types)
                  .map((typeCode) => getType(types[typeCode].NAME, typeCode))
                  .sort((a, b) => a.sort - b.sort)
                  .map((item) => (
                    <option key={item.code} value={item.code}>
                      {item.name} {item.gen}
                    </option>
                  ))}
              </select>
            )}
            {params?.marka > 0 && <div onClick={resetAll}>Сбросить все</div>}
            {autos.length > 0 && (
              <div
                className={styles.SelectMy}
                onClick={() => setIsSelectOther(false)}
              >
                <Icon width={20} height={15} id="arrowcatalog" />
                Назад к вашим авто
              </div>
            )}
          </>
        )}
      </div>
    </>
  ) : null;
}
